var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.522,
    height: 20.027,
    viewBox: "0 0 19.522 24.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11443",
    "data-name": "Path 11443",
    d: "M51.894,228.505H49.266a4.505,4.505,0,1,0-9.01,0H37.628a2.628,2.628,0,0,0-.375,5.229v12.041a2.255,2.255,0,0,0,2.253,2.253H50.017a2.255,2.255,0,0,0,2.253-2.253V233.734a2.628,2.628,0,0,0-.375-5.229Zm-7.133-3a3.006,3.006,0,0,1,3,3H41.758A3.006,3.006,0,0,1,44.761,225.5Zm7.133,6.758H50.768v13.515a.752.752,0,0,1-.751.751H39.505a.752.752,0,0,1-.751-.751V232.259H37.628a1.126,1.126,0,0,1,0-2.253H51.894a1.126,1.126,0,0,1,0,2.253Z",
    transform: "translate(-35 -224)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11444",
    "data-name": "Path 11444",
    d: "M43.751,237a.751.751,0,0,0-.751.751v9.761a.751.751,0,0,0,1.5,0v-9.761A.751.751,0,0,0,43.751,237Z",
    transform: "translate(-36.993 -227.239)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11445",
    "data-name": "Path 11445",
    d: "M51.751,237a.751.751,0,0,0-.751.751v9.761a.751.751,0,0,0,1.5,0v-9.761A.751.751,0,0,0,51.751,237Z",
    transform: "translate(-38.986 -227.239)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11446",
    "data-name": "Path 11446",
    d: "M47.751,237a.751.751,0,0,0-.751.751v9.761a.751.751,0,0,0,1.5,0v-9.761A.751.751,0,0,0,47.751,237Z",
    transform: "translate(-37.99 -227.239)",
    fill: "#606060"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5cfc452ca0150b5558c6bbf44df214af.svg";
export { ForwardRef as ReactComponent };